import { render, staticRenderFns } from "./HospitalsEdit.vue?vue&type=template&id=20b1e16a&"
import script from "./HospitalsEdit.vue?vue&type=script&lang=js&"
export * from "./HospitalsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports